module.exports = "<div id=inbox> <title title=\"All Mails\"></title> <div v-if=$loadingAsyncData class=\"mdl-spinner mdl-js-spinner is-active\"></div> <list v-if=!$loadingAsyncData :mails=mails></list> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/All.vue
 ** module id = 24
 ** module chunks = 0
 **/